import { t } from '@lingui/core/macro';
import { TextField } from 'shared/domains/forms';
function EmailField() {
    return (<div>
      <TextField label={t `Email`} name="email"/>
    </div>);
}
export default EmailField;
